// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/AddAction/Add/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_AddAction_Add_Content($object: vaxiom_procedures_insert_input!) {
  insert_vaxiom_procedures_one(object: $object) {
    id
  }
}

`